import { useEffect, useState } from 'react';

// The view of the demand panel (decision 18): Chart or Calendar. The browser remembers the last
// view, as the Full width table and the Market Booking Curve do. Default: Chart.
export type MarketDemandView = 'chart' | 'calendar';

const VIEW_STORAGE_KEY = 'roompulse-market-demand-view';

const readView = (): MarketDemandView => {
	try {
		return window.localStorage.getItem(VIEW_STORAGE_KEY) === 'calendar' ? 'calendar' : 'chart';
	} catch {
		return 'chart';
	}
};

export const useMarketDemandView = (): [MarketDemandView, (view: MarketDemandView) => void] => {
	const [view, setView] = useState<MarketDemandView>(readView);
	const change = (next: MarketDemandView) => {
		setView(next);
		try {
			window.localStorage.setItem(VIEW_STORAGE_KEY, next);
		} catch {
			// a browser can refuse the storage; the choice then lasts for the page only
		}
	};
	return [view, change];
};

// Below the sm breakpoint (640 px) the chart shows 14 dates per page and the calendar one month
// (decision 12). The desktop keeps 61 dates and three months.
const PHONE_QUERY = '(max-width: 639px)';

export const useIsPhone = (): boolean => {
	const [phone, setPhone] = useState<boolean>(() => window.matchMedia(PHONE_QUERY).matches);
	useEffect(() => {
		const media = window.matchMedia(PHONE_QUERY);
		const update = () => setPhone(media.matches);
		media.addEventListener('change', update);
		return () => media.removeEventListener('change', update);
	}, []);
	return phone;
};
